import { TenantNotificationPayload } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

export const EntityRooms = {
    job: (jobId: string): RoomKey<TenantNotificationPayload> => ({ key: `job:${jobId}` }),
    quote: (quoteId: string): RoomKey<TenantNotificationPayload> => ({ key: `quote:${quoteId}` }),
    claim: (jobId: string): RoomKey<TenantNotificationPayload> => ({ key: `claim:${jobId}` }),
    site: (siteId: string): RoomKey<TenantNotificationPayload> => ({ key: `site:${siteId}` }),
    customer: (customerId: string): RoomKey<TenantNotificationPayload> => ({ key: `customer:${customerId}` }),
    task: (taskId: string): RoomKey<TenantNotificationPayload> => ({ key: `task:${taskId}` }),
    jobs: (): RoomKey<TenantNotificationPayload> => ({ key: 'jobs' }),
    quotes: (): RoomKey<TenantNotificationPayload> => ({ key: 'quotes' }),
    claims: (): RoomKey<TenantNotificationPayload> => ({ key: 'claims' }),
    sites: (): RoomKey<TenantNotificationPayload> => ({ key: 'sites' }),
    customers: (): RoomKey<TenantNotificationPayload> => ({ key: 'customers' }),
};
